"use strict";

exports.__esModule = true;
exports.PlantListContext = void 0;
var _Utils = require("../../../Utils");
/**
 * Provides a list of devices to consumers.
 * @component
 */
var PlantListContext = exports.PlantListContext = (0, _Utils.createEnhancedContext)({
  propName: "plantList"
});